const language = window.localStorage.getItem('language');

export const noClaimCertificate = [
    { value: 1, label: language === 'ar' ? 'لا - ليس لدي شهادة' : "No - I have no certificate" },
    { value: 2, label: language === 'ar' ? 'نعم - سنة واحدة مع إثبات' : "Yes - 1 year with proof" },
    { value: 3, label: language === 'ar' ? 'نعم - سنتين مع إثبات' : "Yes - 2 years with proof" },
    { value: 4, label: language === 'ar' ? 'نعم - 3 سنوات أو أكثر مع إثبات' : "Yes - 3 or more years with proof" }
]